/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Type of accommodation unit ‘nights’ or ‘days’
 * @export
 */
export const TravelineStayUnitKindDto = {
    NightRate: 'NightRate',
    DailyRate: 'DailyRate'
} as const;
export type TravelineStayUnitKindDto = typeof TravelineStayUnitKindDto[keyof typeof TravelineStayUnitKindDto];


export function instanceOfTravelineStayUnitKindDto(value: any): boolean {
    for (const key in TravelineStayUnitKindDto) {
        if (Object.prototype.hasOwnProperty.call(TravelineStayUnitKindDto, key)) {
            if (TravelineStayUnitKindDto[key as keyof typeof TravelineStayUnitKindDto] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TravelineStayUnitKindDtoFromJSON(json: any): TravelineStayUnitKindDto {
    return TravelineStayUnitKindDtoFromJSONTyped(json, false);
}

export function TravelineStayUnitKindDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TravelineStayUnitKindDto {
    return json as TravelineStayUnitKindDto;
}

export function TravelineStayUnitKindDtoToJSON(value?: TravelineStayUnitKindDto | null): any {
    return value as any;
}

export function TravelineStayUnitKindDtoToJSONTyped(value: any, ignoreDiscriminator: boolean): TravelineStayUnitKindDto {
    return value as TravelineStayUnitKindDto;
}

